import React from 'react';
import { productName } from '../data/offer';
export function Footer() {
  return <footer className="bg-earth-900 text-earth-200" data-id="element-95" data-mp="3geze367ujv27">
      <div className="furrow-bar h-2 w-full" aria-hidden="true" data-id="element-96" data-mp="3ggk72reij5xy" />
      <div className="mx-auto max-w-3xl px-4 py-10 text-center" data-id="element-97" data-mp="32onkf2vm5o8y">
        <p className="font-display text-lg font-extrabold uppercase tracking-tight text-gold-400" data-id="element-98" data-mp="36pfu1x8edv5r">{productName}</p>
        <p className="mt-3 text-sm" data-id="element-99" data-mp="3ueijvsd6qubc">Hecho por especialistas, para docentes de Latinoamérica.</p>
        <p className="mt-6 border-t border-earth-700 pt-6 text-xs" data-id="element-100" data-mp="38h456i9zcjd">
          © 2026 Megapack Minería Listo — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}